
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M19.95 5.536l-3.485-3.485a6.954 6.954 0 00-4.95-2.05H7A5.004 5.004 0 002 5v14c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5v-8.515c0-1.87-.728-3.627-2.05-4.95zM18.536 6.95c.318.318.587.671.805 1.05H15c-.551 0-1-.449-1-1V2.659c.379.218.733.487 1.05.805l3.485 3.485zM20 19c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h4.515c.163 0 .325.008.485.023V7c0 1.654 1.346 3 3 3h4.977c.015.16.023.322.023.485V19zm-4.5-6h-7A2.503 2.503 0 006 15.5v2C6 18.878 7.122 20 8.5 20h7c1.378 0 2.5-1.122 2.5-2.5v-2c0-1.378-1.122-2.5-2.5-2.5zm.5 4.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v2zM6 10a1 1 0 011-1h2a1 1 0 010 2H7a1 1 0 01-1-1zm0-4a1 1 0 011-1h2a1 1 0 010 2H7a1 1 0 01-1-1z"}})])
          )
        }
      }
    